import React, { useEffect, useState } from "react";
import StoreHeader from "../../Component/StoreHeader/StoreHeader";
import StoreMenu from "../../Component/StoreMenu/StoreMenu";
import StoreMenuProduct from "../../Component/StoreMenuProduct/StoreMenuProduct";
import Style from "./Store.module.css";
import { getSupplierInfo } from "../../Api/BarestServices";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import SupermarketCategoryPart from "../../Component/SupermarketCategoryPart/SupermarketCategoryPart";
import MenuBottom from "../../Component/menuBottom/MenuBottom";
import { errorToast } from "../../Toast/Toast";
const Store = () => {
  const [Details, setDetails] = useState();
  useEffect(() => {
    getSupllierDetails();
  }, []);
  const getSupllierDetails = async () => {
    const path = window.location.pathname.split("/");
    getSupplierInfo(path[2],(succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setDetails(res);
        }
      }else{
        console.error(res)
      }
    })
  };
  let loadingHandler = null;
  if (Details === undefined) {
    loadingHandler = (
      <div className={Style.loading2Test}>
        <PointSpreadLoading color={"#ab0c59"} size={"small"} />
      </div>
    );
  } else {
    loadingHandler = (
      <div className={Style.fixPage}>
        <StoreHeader data={Details.supplier} />

        {Details.supplier.type === "food" ? (
          <StoreMenu
            supId={Details.supplier.id}
            products={Details.categories}
          />
        ) : null}

        {Details.supplier.type === "supermarket" ? 
          <SupermarketCategoryPart
          categoryList={Details.categories}
          supId={Details.supplier.id}
          />
          : 
          <StoreMenuProduct
            forceUpdate={getSupllierDetails}
            supId={Details.supplier.id}
            products={Details.categories}
          />
        }
        
      </div>
    );
  }

  return (
    <div className={Style.PageHolder}>
      {loadingHandler}
      <MenuBottom/>
    </div>
  )
};

export default Store;
